import React from "react";

const FrontCommerceIcon = ({ size }) => {
  return (
    <svg
      version="1.1"
      id="Layer_1"
      x="0px"
      y="0px"
      width={size}
      height={size}
      viewBox="0 0 259.8 300"
    >
      <g id="Group_4928" transform="translate(-768.325 -313.272)">
        <path
          id="Path_1"
          stroke="#FFF"
          style={{ fill: "#FFF" }}
          d="M963.1,425.8l65-37.5l-129.9-75l-129.9,75v150l65.1,37.6l-0.1-75.2l64.9,37.5v-74.9l-64.9-37.5
		l64.9-37.5L963.1,425.8z"
        />

        <path
          id="Path_2"
          stroke="#FFF"
          style={{ fill: "#FFF" }}
          d="M963.1,500.7l65,37.6l-129.9,75v-75.1L963.1,500.7z"
        />
      </g>
    </svg>
  );
};

export default FrontCommerceIcon;
